import React from 'react';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid/dist/styles/ag-grid.css';
import 'ag-grid/dist/styles/ag-theme-balham.css';

class QAGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [
                {
                    headerName: "類別",
                    field: "type",
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    rowDrag: true,
                    minWidth: 110
                },
                {
                    headerName: "常見問題",
                    field: "question",
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    minWidth: 100
                },
                {
                    headerName: "問題答覆",
                    field: "answer",
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    cellStyle: { textAlign: "left", verticalAlign: "middle" },
                    minWidth: 150
                },
                {
                    headerName: "附件下載",
                    field: "download",
                    cellClass: "cell-wrap-text",
                    autoHeight: true,
                    minWidth: 100,
                    cellRenderer: (params) => {
                        let text = params.value.split('@')[0];
                        let link = params.value.split('@')[1];
                        return '<a href="' + link + '" target="_blank" title="點擊下載文件或開啟網頁" download>' + text + '</a>';
                    }
                }
            ],
            rowData: [],
            defaultColDef: { editable: true }
        }
    }
    
    componentDidMount() {
        fetch('./QAdata_example.json')
            .then(function(response){ return response.json()})
            .then((data) => this.setState({ rowData: data }));
    }

    onGridReady = (params) => {
        window.addEventListener("resize", function () {
            params.api.sizeColumnsToFit();
        });
        let trigger = document.getElementsByClassName("trigger")[0];
        trigger.addEventListener("click", function () {
            setTimeout(function () {
                params.api.sizeColumnsToFit();
            }, 700);
        });
        //欄位自動調整寬度API
        params.api.sizeColumnsToFit();
    }
    render() {
        return (
            <div
                className="ag-theme-balham"
                style={{
                    height: "100%",
                    width: "100%"
                }}
            >
                <AgGridReact
                    enableSorting={true}
                    enableFilter={true}
                    enableColResize={true}
                    rowDragManaged={true}
                    //uncomment this line to active dbclick edit 
                    //defaultColDef={this.state.defaultColDef}
                    columnDefs={this.state.columnDefs}
                    rowData={this.state.rowData}
                    onGridReady={this.onGridReady}
                >
                </AgGridReact>
            </div>
        );
    }
}

export default QAGrid;


// WEBPACK FOOTER //
// ./src/components/QAGrid.js